import { DateTime } from '@ksyos/date-time';
import type { IOtpMethod } from '../interfaces/otpMethod';

export const noMfaTimeAmount = 72;
export const noMfaTimeUnit = 'hours';
export function practitionerHasMfaTemporarilyDisabled(mfaVerificationSwitchedOffOn?: Date | string | null) {
    return (
        mfaVerificationSwitchedOffOn &&
        DateTime.from(mfaVerificationSwitchedOffOn).add(noMfaTimeAmount, noMfaTimeUnit).isAfter(DateTime.now())
    );
}

export function practitionerHasMfaMethod(otpMethod: IOtpMethod | null) {
    return otpMethod?.otpAppId || otpMethod?.otpDeviceId;
}
